"use client";
import { CareerStatsContent } from "@/lib/content";

export default function CompanyStats() {
  return (
    <section 
      className="w-full py-16 bg-white" 
      aria-label="Company Achievements"
    >
      <div className="max-w-7xl mx-auto px-6">
        
        <div 
          className="grid grid-cols-1 md:grid-cols-3 text-center divide-y md:divide-y-0 md:divide-x divide-gray-200 border-y md:border-y-0 border-gray-100"
          role="list"
        >
          {CareerStatsContent.map((stat, index) => (
            <div 
              key={index} 
              className="py-12 md:py-8 flex flex-col items-center group transition-all duration-500"
              role="listitem"
            >
              
              {/* Number - Scaled for impact */}
              <span 
                className="text-6xl md:text-7xl font-extrabold text-[#4F7AC2] tracking-tighter mb-2 animate-in fade-in zoom-in-95 duration-1000"
                aria-label={stat.aria}
              >
                {stat.value}
              </span>

              {/* Label - Improved Contrast and Spacing */}
              <p className="text-sm md:text-base tracking-[0.2em] text-gray-500 font-black uppercase">
                {stat.label}
              </p>

              {/* Decorative element for premium feel */}
              <div 
                className="mt-4 w-0 group-hover:w-12 h-1 bg-[#4F7AC2] transition-all duration-500 rounded-full" 
                aria-hidden="true" 
              />

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}